<template>
  <div class="fair-survey-step fair-survey-step--thank-you">
    <div class="fair-survey-step__head fair-survey-step__head--centered">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <FairButton
      class="fair-survey-step__cta"
      label="Продолжить"
      variant="primary"
      size="m"
      :rounded="false"
      @click="nextStep"
    />
  </div>
</template>

<script setup lang="ts">
import { useTasteClarificationModal } from '@/features/taste/store'
import type { TasteStep } from '@/features/taste/types/taste-config'
import { FairButton } from '@/ui/primitives/FairButton'

defineProps<{ step: TasteStep & { type: 'thank_you' } }>()

const tasteStore = useTasteClarificationModal()

function nextStep() {
  tasteStore.nextStep()
}
</script>

<style scoped>
.fair-survey-step--thank-you {
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fair-survey-step__cta {
  align-self: center;
}
</style>
